import React, {memo} from 'react';

type PaddingBottomProps = {
  amount: number;
};

export const PaddingBottom = memo(({amount}: PaddingBottomProps) => {
  return <div style={{paddingBottom: amount}} />;
});
